export default __webpack_public_path__ + "static/media/Group 10690.5053a1d8.svg";